import { createReducer, on } from '@ngrx/store';

import { handleChatDrafts } from '@lib/chat/core/functions/handle-chat-drafts.function';
import { ChatState } from '@lib/chat/models/chat.state.interface';
import { clearChatDraftByThread, clearChatDrafts, getChatDraftsSuccess, setChatDraft } from '@lib/chat/store/chat.actions';

const initialState: ChatState = {
  chatDrafts: [],
};

export const chatReducer = createReducer(
  initialState,
  on(getChatDraftsSuccess, (state, { chatDrafts }) => ({
    ...state,
    chatDrafts,
  })),
  on(setChatDraft, (state, { chatDraft }) => ({
    ...state,
    chatDrafts: handleChatDrafts(state.chatDrafts, chatDraft),
  })),
  on(clearChatDraftByThread, (state, { chatDraft }) => ({
    ...state,
    chatDrafts: handleChatDrafts(state.chatDrafts, chatDraft),
  })),
  on(clearChatDrafts, state => ({
    ...state,
    chatDrafts: initialState.chatDrafts,
  }))
);
